module.exports = __webpack_public_path__ + "img/lapnotification.c732a1e5.svg";